import {idbDelete,idbGet,idbSet} from './indexedDb';
import {deleteObject,getBlob,getDownloadURL,getMetadata,ref,uploadBytes} from 'firebase/storage';
import {storage as firebaseStorage} from '../config/firebase';

/** Binary adapter boundary. Firebase Storage can implement this contract later. */
export interface AudioBinaryStorage {
  putAudioBlob(id:string,blob:Blob):Promise<string|void>;
  getAudioBlob(id:string):Promise<Blob|undefined>;
  deleteAudioBlob(id:string):Promise<void>;
  hasAudioBlob(id:string):Promise<boolean>;
}

export const localAudioStorage:AudioBinaryStorage={
  putAudioBlob:(id,blob)=>idbSet('audioBlobs',id,blob),
  getAudioBlob:id=>idbGet<Blob>('audioBlobs',id),
  deleteAudioBlob:id=>idbDelete('audioBlobs',id),
  hasAudioBlob:async id=>!!(await idbGet<Blob>('audioBlobs',id)),
};

const safeAudioId=(id:string)=>String(id).replace(/[^a-zA-Z0-9_-]/g,'_').slice(0,180);
const remoteRef=(id:string)=>firebaseStorage?ref(firebaseStorage,`reactive-worlds/audio/${safeAudioId(id)}`):null;

/** Shared production storage. IndexedDB remains a read-through cache and offline fallback. */
export const portableAudioStorage:AudioBinaryStorage={
  async putAudioBlob(id,blob){
    await localAudioStorage.putAudioBlob(id,blob);
    const target=remoteRef(id);if(!target)return;
    await uploadBytes(target,blob,{contentType:blob.type||'audio/wav',customMetadata:{audioId:id}});
    return getDownloadURL(target);
  },
  async getAudioBlob(id){
    const cached=await localAudioStorage.getAudioBlob(id);if(cached)return cached;
    const target=remoteRef(id);if(!target)return;
    try{const blob=await getBlob(target,25*1024*1024);await localAudioStorage.putAudioBlob(id,blob);return blob}catch{return undefined}
  },
  async deleteAudioBlob(id){
    await localAudioStorage.deleteAudioBlob(id);const target=remoteRef(id);if(!target)return;
    try{await deleteObject(target)}catch(error){if((error as {code?:string})?.code!=='storage/object-not-found')throw error}
  },
  async hasAudioBlob(id){
    if(await localAudioStorage.hasAudioBlob(id))return true;const target=remoteRef(id);if(!target)return false;
    try{await getMetadata(target);return true}catch{return false}
  }
};
